export { default } from './generic-transition';
